import { useScriptGoogleAdsense, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleAdsense = useScriptGoogleAdsense({"client":"ca-pub-3214580169609807","autoAds":false})
    return { provide: { $scripts: { googleAdsense } } }
  }
})